import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Index from './components/pages/index/index.vue'
import AtComponents from 'at-ui'
import 'at-ui-style'
import VueParticles from 'vue-particles'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import getParam from './components/utils/getParam.js';
import 'babel-polyfill'
import i18n from './assets/i18n/i18n.js'
import 'default-passive-events'
import global_ from './components/toolbar/global_variable.vue'

import { 
    faGlobe,
	faUserCircle,
	faCalculator,
	faTasks
} from '@fortawesome/free-solid-svg-icons';
library.add(
    faGlobe,
	faUserCircle,
	faCalculator,
	faTasks
);
Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon);
// Vue.prototype.$utils=getParam 
Vue.use(AtComponents);
Vue.use(VueParticles);
Vue.use(ElementUI);
// Vue.use(i18n)
// Vue.use(fromatUnit)

Vue.prototype.$urlParse=getParam
Vue.prototype.$global=global_
router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title
}
next()
})
Vue.use(i18n);
new Vue({
	router,
	data: function(){
	        return {
	            open:false,
	        }
	    },
  render: h => h(App),
  i18n
}).$mount('#app')
